import { useTranslation } from 'react-i18next'
import { Offer } from '../../../../domain/dtos/offer'
import { Status } from '../../../../domain/dtos/status'
import { formatLocalNumber } from '../../../../domain/vos/format-local-number'
import { CardInfoBox } from '../../../components/card-info-box'
import { useGetTotalRefund } from '../../../hooks/use-get-total-refund'
import { useRefetch } from '../../../hooks/use-refetch'
import { Loading } from './loading'

type TotalRefundProps = {
  startDate: string
  endDate: string
  offerIds: string[]
  offers: Offer[]
  isLoading: boolean
}

export const TotalRefund = (props: TotalRefundProps) => {
  const { startDate, endDate, offers, offerIds, isLoading } = props
  const { t } = useTranslation()

  const { data, isFetching, refetch } = useGetTotalRefund({ startDate, endDate, offers, offerIds }, isLoading)

  useRefetch({ startDate, endDate, offers, offerIds }, refetch)

  if (isFetching || isLoading) {
    return <Loading />
  }

  const getVariation = () => {
    return {
      indicator: data.indicator,
      status: Status.neutral,
      description: `${data.percentage} ${t('variation', { previous: formatLocalNumber(data.previous) })}`,
    }
  }

  return (
    <CardInfoBox
      title={t('totalRefund.title')}
      description={t('totalRefund.description')}
      current={formatLocalNumber(data.current)}
      variation={getVariation()}
    />
  )
}
